<h3 mat-dialog-title>{{titulo}}</h3>
<div mat-dialog-content style="width: 100%">

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Nome</mat-label>
            <input 
                matInput 
                placeholder="Nome" 
                [formControl]="nome" 
                name="nome" 
                maxlength="255">
        </mat-form-field>   
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>CETIP</mat-label>
            <input 
                matInput 
                placeholder="CETIP" 
                [formControl]="cetip" 
                name="cetip" 
                maxlength="255">
        </mat-form-field>   
    </div>

    <div fxLayout="column" fxLayout.gt-md="row" *ngIf="this.data.campos.cnpj">
        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>CNPJ</mat-label>
            <input 
                matInput 
                placeholder="CNPJ" 
                [formControl]="cnpj" 
                name="cnpj" 
                maxlength="25" 
                mask="00.000.000/0000-00">										            
        </mat-form-field>   
    </div>

    <div fxLayout="column" fxLayout.gt-md="row" *ngIf="this.data.campos.data">
        <mat-form-field appearance="outline" fxLayoutAlign="start" floatLabel="always" fxFlex="45">
            <mat-label>Data Início</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="data_operacao_inicio" name="data_operacao_inicio" placeholder="Data de Início">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" fxLayoutAlign="end" floatLabel="always" fxFlex="45">
            <mat-label>Data Fim</mat-label>
            <input matInput [matDatepicker]="pickerFim" [formControl]="data_operacao_fim" name="data_operacao_fim" placeholder="Data de Fim">
            <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
            <mat-datepicker #pickerFim></mat-datepicker>
        </mat-form-field>              
    </div>     

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>